/* import __COLOCATED_TEMPLATE__ from './items.hbs'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { Keys } from 'ember-headlessui/utils/keyboard';
let Items = (_class = class Items extends Component {
  get menuItemsElementSelector() {
    return `#${this.args.itemsGuid}`;
  }
  onKeydown(event) {
    switch (event.key) {
      // Ref: https://www.w3.org/TR/wai-aria-practices-1.2/#keyboard-interaction-12
      // `Escape` key is handled by focus-trap
      case Keys.Space:
        if (this.args.searchTaskIsRunning) {
          event.preventDefault();
          event.stopPropagation();
          return this.args.search(event.key);
        }
      // eslint-disable-next-line no-fallthrough
      case Keys.Enter:
        if (this.args.activeItem) {
          this.args.activeItem.element.click();
        }
        this.args.closeMenu();
        break;
      case Keys.ArrowDown:
        event.preventDefault();
        event.stopPropagation();
        return this.args.goToNextItem();
      case Keys.ArrowUp:
        event.preventDefault();
        event.stopPropagation();
        return this.args.goToPreviousItem();
      case Keys.Home:
      case Keys.PageUp:
        event.preventDefault();
        event.stopPropagation();
        return this.args.goToFirstItem();
      case Keys.End:
      case Keys.PageDown:
        event.preventDefault();
        event.stopPropagation();
        return this.args.goToLastItem();
      default:
        if (event.key.length === 1) {
          return this.args.search(event.key);
        }
    }
  }
  clickInsideMenuTrigger(event) {
    const buttonElement = document.getElementById(this.args.buttonGuid);

    // The `buttonElement` could not exist if the element has been removed from the DOM
    return buttonElement ? buttonElement.contains(event.target) : false;
  }
  allowClickOutsideFocusTrap(event) {
    return this.clickInsideMenuTrigger(event);
  }
  clickOutsideFocusTrapDeactivates(event) {
    return !this.clickInsideMenuTrigger(event);
  }
}, _applyDecoratedDescriptor(_class.prototype, "onKeydown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onKeydown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "allowClickOutsideFocusTrap", [action], Object.getOwnPropertyDescriptor(_class.prototype, "allowClickOutsideFocusTrap"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clickOutsideFocusTrapDeactivates", [action], Object.getOwnPropertyDescriptor(_class.prototype, "clickOutsideFocusTrapDeactivates"), _class.prototype), _class);
export { Items as default };